import React from 'react';
import { motion } from 'framer-motion';
import { Home, User, Plus, Users, MapPin } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export const BottomNav = ({ onCreateClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Home, label: 'Home', path: '/', testId: 'bottom-nav-home' },
    { icon: MapPin, label: 'Local', path: '/communities', testId: 'bottom-nav-communities' },
    { icon: Plus, label: 'Create', action: onCreateClick, testId: 'bottom-nav-create' },
    { icon: User, label: 'Profile', path: '/my-ideas', testId: 'bottom-nav-profile' },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 pointer-events-none">
      <motion.nav
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        className="bg-white rounded-2xl shadow-lg mx-4 pointer-events-auto border border-cardBorder"
        style={{ marginBottom: 'max(calc(env(safe-area-inset-bottom) + 20px), 20px)' }}
      >
        <div className="flex items-center justify-center px-3 py-3 gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <motion.button
                key={item.label}
                data-testid={item.testId}
                onClick={() => item.action ? item.action() : navigate(item.path)}
                whileTap={{ scale: 0.95 }}
                className={`flex flex-col items-center justify-center py-2 px-3 rounded-lg transition-all ${
                  item.label === 'Create'
                    ? 'bg-primary text-primaryDark shadow-soft'
                    : isActive
                    ? 'text-primaryDark bg-primary/20'
                    : 'text-gray hover:text-grayDark hover:bg-surface'
                }`}
              >
                <Icon className="w-5 h-5" strokeWidth={isActive || item.label === 'Create' ? 2.5 : 2} />
                <span className="text-xs mt-1 font-semibold">{item.label}</span>
              </motion.button>
            );
          })}
        </div>
      </motion.nav>
    </div>
  );
};
